import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" A quick look at your account across time. What a journey! ")
const _hoisted_2 = { class: "flex-grow flex items-center" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-center sm:flex-row sm:items-start flex-wrap justify-around" }
const _hoisted_4 = { class: "flex justify-between self-stretch" }
const _hoisted_5 = { class: "flex flex-col items-center" }
const _hoisted_6 = { class: "text-green-500 font-semibold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", null, "Incoming", -1)
const _hoisted_8 = { class: "flex flex-col items-center" }
const _hoisted_9 = { class: "text-red-500 font-semibold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, "Outgoing", -1)
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Since ")
const _hoisted_13 = ["datetime"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowSmDownIcon = _resolveComponent("ArrowSmDownIcon")!
  const _component_ArrowSmUpIcon = _resolveComponent("ArrowSmUpIcon")!
  const _component_BriefStat = _resolveComponent("BriefStat")!
  const _component_near_symbol = _resolveComponent("near-symbol")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    title: "Brief Stats",
    embed: "embed:stats"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BriefStat, {
            title: "Transactions sent",
            value: _ctx.$filters.number.compact(_ctx.sentCount + _ctx.receivedCount)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ArrowSmDownIcon, { class: "inline align-text-top w-5 text-gray-400" }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.number.compact(_ctx.receivedCount)), 1)
                  ]),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ArrowSmUpIcon, { class: "inline align-text-top w-5 text-gray-400" }),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.number.compact(_ctx.sentCount)), 1)
                  ]),
                  _hoisted_10
                ])
              ])
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_BriefStat, {
            title: "Gas burned",
            value: _ctx.$filters.number.compact(_ctx.gasSpent) + 'gas'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_near_symbol, { class: "w-5 h-5" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$filters.number.standard(
                  +_ctx.$filters.toNear(_ctx.gasTokensSpent).toString(),
                )), 1)
              ])
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_BriefStat, {
            title: "Time with NEAR",
            value: 
              _ctx.$filters.number.standard(_ctx.durationDays | 0) + ' days 🙌'
            
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _hoisted_12,
                _createElementVNode("time", {
                  datetime: _ctx.$filters.nearTimestampToISO(_ctx.creationDate)
                }, _toDisplayString(_ctx.$filters.nearTimestampToLocaleString(
                  _ctx.creationDate,
                  _ctx.DateTime.DATE_MED,
                )), 9, _hoisted_13)
              ])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }))
}